export default __webpack_public_path__ + "static/media/rejectedAcct.2a9e1af0.svg";